import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Space } from '@codex/basics';
import BundleHeader from '../BundleHeader';
import BundleFooter from '../BundleFooter';
import ProductList from '../ProductList';
import Product from '../Product';

export const BundleContent = styled.div`
  background-color: ${props => props.theme.colors.shades[7]};
  border: 1px solid ${props => props.theme.colors.shades[5]};
`;

export const BundleDate = styled.div`
  margin-bottom: 5px;
  color: ${props => props.theme.colors.shades[4]};
  font-size: 12px;
`;

const Bundle = props => (
  <Space bottom="20">
    <BundleHeader discountLabel={props.discountLabel}>
      <span dangerouslySetInnerHTML={{ __html: props.heading }} />
    </BundleHeader>

    <BundleContent>
      <Space all={{ desktopWide: '10 22', default: '10' }}>
        <BundleDate>
          {props.translations.created} {props.dateCreated}
        </BundleDate>

        <ProductList
          mainProductHint={props.translations.mainProductHint}
          mainProduct={props.product}
          addons={props.addons}
        />
      </Space>

      <BundleFooter
        addButtonLabel={props.translations.addToBasket}
        priceDescription={props.priceDescription}
        bundleId={props.id}
        bundleType={props.bundleType}
        addonsIds={props.addons.map(addon => addon.id)}
        productId={props.product.id}
        totalPrice={`${props.translations.total} ${props.totalPrice}`}
        totalSaving={
          props.totalSaving ? `${props.translations.totalSavings} ${props.totalSaving}` : ''
        }
        onAddToBasket={props.onAddToBasket}
      >
        {props.children ? props.children : null}
      </BundleFooter>
    </BundleContent>
  </Space>
);

Bundle.propTypes = {
  addons: PropTypes.arrayOf(PropTypes.shape(Product.propTypes)),
  bundleType: PropTypes.string,
  children: PropTypes.element,
  dateCreated: PropTypes.string,
  discountLabel: PropTypes.string,
  heading: PropTypes.string,
  id: PropTypes.string,
  onAddToBasket: PropTypes.func,
  priceDescription: PropTypes.string,
  product: PropTypes.shape(Product.propTypes),
  totalPrice: PropTypes.string,
  totalSaving: PropTypes.string,
  translations: PropTypes.shape({
    addToBasket: PropTypes.string,
    created: PropTypes.string,
    mainProductHint: PropTypes.string,
    save: PropTypes.string,
    total: PropTypes.string,
    totalSavings: PropTypes.string
  })
};

Bundle.defaultProps = {
  addons: [],
  bundleType: '',
  children: undefined,
  dateCreated: '',
  discountLabel: '',
  heading: '',
  id: '',
  onAddToBasket: () => {},
  priceDescription: '',
  product: PropTypes.shape(Product.defaultProps),
  totalPrice: '',
  totalSaving: '',
  translations: {}
};

export default Bundle;
